import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box
} from "@mui/material";

import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, BarChart, Bar,
  PieChart, Pie, Cell, Legend
} from "recharts";

import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";
import { useAuth } from "../../AuthContext";

const API_URL = process.env.REACT_APP_API_URL;

const COLORS = ["#1976d2", "#FF5722", "#4CAF50", "#9C27B0", "#FFC107"];

const MyRequestsAnalytics = () => {
  const { userId } = useAuth();
  const [stats, setStats] = useState(null);

  const loadStats = async () => {
    const response = await axios.post(`${API_URL}/api/get-user-request-stats/`, {
      user_id: userId,
    });
    setStats(response.data);
  };

  useEffect(() => {
    if (userId) loadStats();
  }, [userId]);

  if (!stats) return <Typography sx={{ p: 5 }}>Loading analytics...</Typography>;

  return (
    <div>
      <Header1 />

      <Box sx={{ p: 4 }}>
        {/* SUMMARY CARDS */}
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2 }}><Typography variant="h6">Total Requests</Typography>
              <Typography variant="h4">{stats.total}</Typography></Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2 }}><Typography variant="h6">Active</Typography>
              <Typography variant="h4" color="green">{stats.active}</Typography></Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2 }}><Typography variant="h6">Inactive</Typography>
              <Typography variant="h4" color="red">{stats.inactive}</Typography></Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card sx={{ p: 2 }}>
              <Typography variant="h6">Avg Price</Typography>
              <Typography variant="h4">${stats.avg_price?.toFixed(2)}</Typography>
            </Card>
          </Grid>
        </Grid>

        {/* LINE CHART: DAILY TREND */}
        <Card sx={{ mt: 4, p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Daily Request Trend
          </Typography>

          <LineChart width={800} height={300} data={stats.daily}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="selectedDate" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="total" stroke="#1976d2" strokeWidth={3} />
          </LineChart>
        </Card>

        {/* BAR CHART: REQUESTS BY LANGUAGE */}
        <Card sx={{ mt: 4, p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Requests by Language
          </Typography>

          <BarChart width={800} height={300} data={stats.languages}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="language" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="total" fill="#4CAF50" />
          </BarChart>
        </Card>

        {/* PIE CHART: ACTIVE VS INACTIVE */}
        <Card sx={{ mt: 4, p: 3 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>Status Distribution</Typography>

          <PieChart width={400} height={300}>
            <Pie
              data={[
                { name: "Active", value: stats.active },
                { name: "Inactive", value: stats.inactive },
              ]}
              cx="50%"
              cy="50%"
              outerRadius={100}
              label
            >
              {COLORS.slice(0, 2).map((color, index) => (
                <Cell key={index} fill={color} />
              ))}
            </Pie>
            <Legend />
          </PieChart>
        </Card>

        {/* PRICE BUCKETS */}
        <Card sx={{ mt: 4, p: 3 }}>
          <Typography variant="h6">Price Distribution</Typography>
          <BarChart
            width={800}
            height={300}
            data={[
              { range: "0-20", total: stats.price_buckets["0-20"] },
              { range: "21-50", total: stats.price_buckets["21-50"] },
              { range: "51-100", total: stats.price_buckets["51-100"] },
              { range: "100+", total: stats.price_buckets["100+"] },
            ]}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="range" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="total" fill="#9C27B0" />
          </BarChart>
        </Card>

      </Box>

      <Footer2 />
    </div>
  );
};

export default MyRequestsAnalytics;
